/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon20Regular = forwardRef('ArrowAUpRightIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.5 3.25a.75.75 0 0 0 0 1.5h7.69L3.47 15.47a.75.75 0 1 0 1.06 1.06L15.25 5.81v7.69a.75.75 0 0 0 1.5 0v-8a2.25 2.25 0 0 0-2.25-2.25h-8Z" })));
});
